import r from "./index.ce.vue.js";
import { defineAndRegisterElement as e } from "../../utils/register-element.js";
const o = e(r);
export {
  o as initMallSpApprovalTrigger
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/mall-sp-approval-trigger/index.js
// module id = 1306
// module chunks = 67